import { render } from "./promotion-table.vue?vue&type=template&id=5b1b9450"
import script from "./promotion-table.vue?vue&type=script&lang=js"
export * from "./promotion-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__